// pages/SearchResults.tsx
import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useSearch } from "../context/SearchContext";
import { useDarkMode } from "../context/DarkModeContext";
import {
  //   Briefcase,
  //   Calendar,
  //   FileText,
  //   Building,
  Filter,
  //   Loader,
} from "lucide-react";

const SearchResults: React.FC = () => {
  const location = useLocation();
  useNavigate();
  const {
    searchFilters,
    searchResults,
    // isSearching,
    performSearch,
    updateFilters,
  } = useSearch();
  const { isDark } = useDarkMode();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get("q");

    if (query) {
      updateFilters({ query });
      performSearch(query);
    }
  }, [location.search, updateFilters, performSearch]);

  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';

  // Similar rendering logic as in SearchBox but expanded for full page
  return (
    <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Search Header */}
        <div
          className={`rounded-lg p-6 mb-6 ${
            isDark ? 'bg-gray-800' : 'bg-white shadow'
          }`}
        >
          <h1
            className={`text-2xl font-bold mb-2 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}
          >
            Search Results
          </h1>
          <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
            {searchResults.length} results for "{searchFilters.query}"
          </p>
        </div>

        <Helmet>
          <title>
            {query ? `${query} Jobs in Kenya` : 'Search Jobs in Kenya'} |
            FindWork
          </title>
          <meta
            name="description"
            content={`Find ${query || 'local'} jobs near you in Kenya. Browse verified listings and apply instantly on FindWork.`}
          />
          <link
            rel="canonical"
            href={`https://findwork.ltd/search${query ? `?q=${encodeURIComponent(query)}` : ''}`}
          />
        </Helmet>

        {/* Results Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Filters Sidebar */}
          <div
            className={`lg:col-span-1 rounded-lg p-6 ${
              isDark ? 'bg-gray-800' : 'bg-white shadow'
            }`}
          >
            <h3
              className={`font-semibold mb-4 flex items-center ${
                isDark ? 'text-white' : 'text-gray-900'
              }`}
            >
              <Filter size={16} className="mr-2" />
              Filters
            </h3>
            {/* Add filter components here */}
          </div>

          {/* Results List */}
          <div className="lg:col-span-3 space-y-4">
            {/* Render search results similar to SearchBox but expanded */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
